import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { NewCoachRequest, NewCoachResponse, PublicCoach } from "@/services/bedrock/dtos/Coaches";

const COACHES_SERVICE = `${Constants.API_URL}/bedrock/coaches`;

export class CoachesServices {
  @scCatchServiceException()
  static async createCoach(request: NewCoachRequest): Promise<NewCoachResponse> {
    const { data } = await axios.post<NewCoachResponse>(COACHES_SERVICE, request);
    return data;
  }

  @scCatchServiceException()
  static async getPublicCoach(coachId: number): Promise<PublicCoach> {
    const { data } = await axios.get<PublicCoach>(COACHES_SERVICE + `/${coachId}/public`);
    return data;
  }
}
